import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: 'X-Axis Label'
            },
            grid: {
              drawOnChartArea: false
            }
          },
          y: {
            title: {
              display: true,
              text: 'Y-Axis Label'
            },
            ticks: {
              stepSize: 1
            }
          }
        }
      })
    }
  },
  watch: {
    chartdata: function () {
      this.renderChart(this.chartdata, this.options)
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/charts/line.js